/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $WorkflowStatus = {
  type: 'Enum',
} as const;
